import { Component,OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import {MydataService} from '../home/mydata.service';
import {MyUrlService} from '../home/checkUrll';
import {MyvariableService} from '../home/constantvariable';
import {JsonData} from '../home/dataaa';
import {HomePage} from "../home/home";
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';

@Component({
	selector: 'page-otp',
	templateUrl: 'otp.html',
	providers:[MydataService,MyUrlService,JsonData,MyvariableService]
})
export class OtpPage implements OnInit{
	jsonDt : Array<JsonData>;
	private todos : FormGroup;
	private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home' ];
	phonenos = window.localStorage.getItem('phoneno');
	otphead= this.MyvariableService.OTPHEADING;
	typee:string;
	OTPSEND= this.MyvariableService.OTPSEND;
	constructor(public otpCtrl: NavController,public loading: LoadingController,public alerCtrl: AlertController,private formBuilder: FormBuilder, private myurlService: MyUrlService,private mydataService: MydataService,private MyvariableService: MyvariableService) {
		
		var xyz = window.localStorage.getItem('sinupid');
		
		//alert(xyz);
		this.todos  = this.formBuilder.group({
			userid: [xyz,Validators.required],
			otp: ['',Validators.required],
			password:['',Validators.required],
		});
	}
	
	otpForm(otpvalue,passwordd,confirmpass)
	{
		if(passwordd !=confirmpass){this.showErrorAlert();}else{
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var kiloSabjiJSONdata = JSON.stringify(this.todos.value);
			//console.log("Button Click"+"\n"+"kilo Sabji Url--->"+this.myurlService.OTPURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.OTPURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.otpService(loader));
				
			});
			}
		}
	}
	
	
	
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
		}
		
	otpService=function(loader){
		//console.log("jsondata ==>"+JSON.stringify(this.jsonDt.categorydata));
		
		let uid = this.jsonDt.sinupdata;
		let msg = this.jsonDt.msg;
		this.OTPERROR= this.MyvariableService.OTPERROR;
		window.localStorage.setItem('userid',  uid);
		//alert(msg);
		//alert(uid);
		loader.dismiss();
		if(msg=='Register  successfully'){
			
			this.otpCtrl.push(HomePage);
			if(window.localStorage.getItem('otpTypee')!='changepass'){
			this.SendOtpFunc("signup");
			}
			
			}else{
			//alert(msg);
			this.showAlert();
		}
		
	}
	
	_keyPress(event: any) {
		const pattern = /[0-9\ ]/;
		let inputChar = String.fromCharCode(event.charCode);
		
		if (!pattern.test(inputChar)) {
			
			if(this.specialKeys.indexOf(event.key) !== -1)
			{
				return;
				// invalid character, prevent input
				
			}
			//alert('Enter The Number');
			event.preventDefault();
		}
	}
	
	//this.otphead= this.MyvariableService.OTPHEADING;
	//this.otpfoot= this.MyvariableService.OTPFOOTER;
	//this.otpfooters= this.MyvariableService.OTPFOOTERS;
	
	
	forgotpass(mobile)
	{
		//alert(mobile);
		
		//console.log(mobile);
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var kiloSabjiJSONdata = JSON.stringify({"mobileno":mobile});
			//console.log("Button Click"+"\n"+"kilo Sabji Url--->"+this.myurlService.FORGOTPASS+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.FORGOTPASS ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.forGetPassService(loader));
			});
			
		}
		
		
	}
	
	forGetPassService=function(loader){
		////console.log("jsondata ==>"+JSON.stringify(this.jsonDt.sinupdata));
		
		let uid = this.jsonDt.sinupdata;
		let msg = this.jsonDt.msg;
		this.LOGINFORGOTWRONG= this.MyvariableService.LOGINFORGOTWRONG;
		// alert(uid);
		loader.dismiss();
		if(uid!=''){
			window.localStorage.setItem('sinupid',  uid);
			window.localStorage.setItem('phoneno',  msg);
			this.mobile = window.localStorage.getItem('phoneno');
			var xyz = window.localStorage.getItem('sinupid');
			
			this.showAlerwrongmobile();
			
			}else{
			
		}
		
		
		
	}
	showErrorAlert=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: "Enter same password in both password fields.",
			buttons: ['OK']
		});
		alert.present();
	}
	
	showAlerwrongmobile=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.OTPSEND +' '+ this.mobile,
			buttons: ['OK']
		});
		alert.present();
	}
	showAlert=function() {
		
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: this.OTPERROR,
			buttons: ['OK']
		});
		alert.present();
	}
	
	
	ngOnInit()
	{
	var datatat= window.localStorage.getItem('otpTypee');
	
		if(datatat==null){
			this.SendOtpFunc("register");
		}else{
			this.SendOtpFunc("changepass");
		}
		//window.localStorage.removeItem('otpTypee');
		
	}
	SendOtpFunc=function(regis){
		var userid = window.localStorage.getItem('sinupid');
		//alert(userid);
		//console.log(userid+"vvv   "+regis);
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			
			var kiloSabjiJSONdata = JSON.stringify({"userid":userid,"type":regis});
			//console.log("Button Click"+"\n"+"kilo Sabji Url--->"+this.myurlService.SENDOTP+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			
			this.mydataService.postJSON(this.myurlService.SENDOTP ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => console.log(''),() =>this.sendotps());
			
		}
	}
	sendotps=function(){
		
	}
}



// WEBPACK FOOTER //
// ./src/pages/otp/otp.ts